import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { SelectedDateContainer, TimesContainer, TimeIndicator } from './styled'
import chunk from 'lodash.chunk'
import FlexHorizontalDrag from '@/components/Draggers/FlexHorizontalDrag'

interface Props {
  day: number
  monthName: string
  setTime: (time: string) => void
  selectedTime: string
  times: string[]
}

const Times: React.FC<Props> = ({
  times,
  selectedTime,
  setTime,
  day,
  monthName,
}) => {
  const splitTimes = chunk(times, 2)
  const containerRef = useRef(null)
  return (
    <>
      <SelectedDateContainer>
        {day} {monthName}
      </SelectedDateContainer>
      <TimesContainer ref={containerRef}>
        <FlexHorizontalDrag parentRef={containerRef}>
          {splitTimes.map((splitTime) => (
            <div>
              {splitTime.map((displayTime) => {
                const isSelected = selectedTime === displayTime
                const className = isSelected ? 'selected' : ''
                return (
                  <TimeIndicator
                    className={className}
                    onPointerDown={() => setTime(displayTime)}
                    key={displayTime}
                  >
                    {displayTime}
                  </TimeIndicator>
                )
              })}
            </div>
          ))}
        </FlexHorizontalDrag>
      </TimesContainer>
    </>
  )
}

Times.defaultProps = {}

Times.propTypes = {
  selectedTime: PropTypes.string.isRequired,
  setTime: PropTypes.func.isRequired,
  day: PropTypes.number.isRequired,
  monthName: PropTypes.string.isRequired,
}

export default Times
